// extracted by mini-css-extract-plugin
export default {"root":"WStfcy8dhewCkEd89xlu","wrap":"jOaJ7dNRhP9cSIIVHOAA","back":"muShDZyWU3Xh2ZtnbDNH"};